import { AxiosResponse } from 'axios';

import { axiosInstance } from './axios.config';
import { ResponseREST, ResponseUser } from './response.type';

interface ResponseSuccessPostUser extends ResponseREST {
  data: ResponseUser;
}

export interface Body {
  code: string;
  state: string;
}

export const postCheckUserLark = async (body: Body): Promise<ResponseSuccessPostUser> => {
  return axiosInstance
    .post('check-user-lark', body)
    .then((res: AxiosResponse<ResponseSuccessPostUser>) => res.data)
    .catch((err) => err);
};
